import { FieldQueryFilterName, FieldQueryOptions } from '@cibo/core'
import { createContext, useContext } from 'react'

export interface HideFilters extends Partial<Record<FieldQueryFilterName, boolean>> {
  fdrStatusAnyOf?: boolean
}

export interface PaginatedFieldsState {
  page: number
  setPage(page: number): void
  pageSize: number
  setPageSize(page: number): void
  filters: FieldQueryOptions
  setFilters: (filters: FieldQueryOptions) => void
  baseFilters: FieldQueryOptions
  setBaseFilters: (filters: FieldQueryOptions) => void
  hideFilters: HideFilters

  isReady: boolean
}

export const PaginatedFieldsContext = createContext<PaginatedFieldsState>({
  filters: {},
  setFilters: console.log,
  baseFilters: {},
  setBaseFilters: console.log,
  hideFilters: {},

  page: 0,
  setPage: console.log,
  pageSize: 10,
  setPageSize: console.log,
  isReady: false,
})
PaginatedFieldsContext.displayName = 'PaginatedFieldsContexts'

export const usePaginatedFieldsContext = () => useContext(PaginatedFieldsContext)
